import React from 'react';
import { Label } from 'fw/components';
import { Form, TextBox, CheckBox, EmailBox } from 'fw/forms';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';
import { DocumentUpload } from "areas/shared/controls";
import { BusinessStaffPopUpHelpers } from 'areas/shared/helpers';

class BusinessStaffPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,

            form: {
                resumeStorageToken: null,
                resumeFileName: null,
                phones: []
            }
        }
    }

    componentDidUpdate() {
        //Add a phone control to be filled
        if (this.state.form.phones.length === 0)
            this.handleAddPhone();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: nextProps.currentBusinessStaff
        });
    }

    onValidate = (form) => {
        let requiredFields = true;

        if (this.state.form.firstName === '' || this.state.form.firstName === null){
            requiredFields = false;
            this._firstName._input.flag(false);
        }
        else
            this._firstName._input.flag(true);

        if (this.state.form.lastName === '' || this.state.form.lastName === null){
            requiredFields = false;
            this._lastName._input.flag(false);
        }
        else
            this._lastName._input.flag(true);

        if (this.state.form.title === '' || this.state.form.title === null){
            requiredFields = false;
            this._title._input.flag(false);
        }
        else
            this._title._input.flag(true);

        if (!this.state.form.doNotSolicit && (this.state.form.email === '' || this.state.form.email === null)){
            requiredFields = false;
            this._email._input.flag(false);
        }
        else
            this._email._input.flag(true);
            
        for (var ref in this.refs) {
            if (ref === 'phone_0' && this.refs[ref] != null && this.refs[ref]._input !== null && this.refs[ref]._input.getValue() !== null)
            {
                if (!this.state.form.doNotSolicit && (this.refs[ref]._input.getValue().number === null || this.refs[ref]._input.getValue().number === ""))
                {
                    requiredFields = false;
                    this.refs[ref]._input.flag(false);
                }
                else
                    this.refs[ref]._input.flag(true);
            }
        }
        if (form.resumeStorageToken === null)
        {
            this._resume._fileBox.flagError(false);
            requiredFields = false;
        }
        else
            this._resume._fileBox.flagError(true);

        // Some required fields not filled-in?
		if (!requiredFields) {
			return "Please review required fields.";
		}
    }

    save = () => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }

        if (!this._form.validate())
            return;

        this.props.onSave(this.state.form);
        this.close();
    }

    close = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose();
        });
    }

    onChange = (form) => {
        this.setState({ form });
    }

    handleResumeUploadChange = (file) => {
        let form = this.state.form;
        form.resumeStorageToken = file.storageToken;
        form.resumeFileName = file.fileName;

        this.setState({ form: form });
    }

    handleAddPhone = () => {
        const phones = this.state.form.phones;

        phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({
            phones
        });
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = "";
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones;

        phones[i] = v;
        
        this.setState({ form: { ...this.state.form, phones } })
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Staff &amp; Responsibilities – <small>Please identify primary decision makers within your Company</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.onChange}
                        values={this.state.form}
                        onValidate={this.onValidate}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col md={7}>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="firstName" required>First Name</Label>
                                            <TextBox
                                                name="firstName"
                                                placeholder="First Name"
                                                maxLength={30}
                                                ref={(ref) => { this._firstName = ref }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="lastName" required>Last Name</Label>
                                            <TextBox
                                                name="lastName"
                                                placeholder="Last Name"
                                                maxLength={30}
                                                ref={(ref) => { this._lastName = ref }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="title" required>Title</Label>
                                            <TextBox
                                                name="title"
                                                placeholder="Title"
                                                maxLength={25}
                                                ref={(ref) => { this._title = ref }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="email" required={!this.state.form.doNotSolicit}>Email</Label>
                                            <EmailBox
                                                name="email"
                                                placeholder="Email"
                                                ref={(ref) => { this._email = ref }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
								{BusinessStaffPopUpHelpers.renderPhones(this.state.form, this.handlePhoneChange, this.handleAddPhone, this.handleRemovePhone)}
                            </Col>
                            <Col md={5}>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="resume" required>Resume</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.resumeStorageToken}
                                                fileName={this.state.form.resumeFileName}
                                                onChange={this.handleResumeUploadChange}
                                                wrapFileNameLength={30}
                                                ref={(ref) => { this._resume = ref }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <br />
                                            <CheckBox name="doNotSolicit" label="Please do not contact" style={{ marginTop: "-8px" }} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={this.save}>Save</Button>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default BusinessStaffPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/businessStructure/businessStaffPopUp.js